export default [
  {
    name: 'project_member_navigation',
    component_path: 'modules/templates/TemplateNavigation',
    is_allowed: {
      role: ['project_member', 'super_admin', 'koalect']
    }
  }
]